import React, { useState } from "react";
import * as icons from 'react-bootstrap-icons';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MenuDrawer from "./MenuDrawer";
import { HandleVibrate } from "Utils/Helpers/HandleApiData";

export default function AppMenu({ user_name, clinic_name }) {
  const [show, setShow] = useState(false);
  const handleClick = () => {
    setShow(!show);
  }
  const onMouseUp = (e) => {
    HandleVibrate();
  }
  return (
    <>
      <div className='menu-app' onClick={handleClick} onMouseUp={onMouseUp}>
        <icons.List size={40}/>
      </div>
      <div>
        <SwipeableDrawer
          anchor={'top'}
          open={show}
          onClose={() => setShow(false)}
        >
          <Box
            sx={{ width: 'auto', bgcolor: '#435B69' }}
            role="presentation"
            onClick={() => setShow(false)}
            onKeyDown={() => setShow(false)}
          >
            <div className="flex-row-center-center pt-4 text-white">
              <strong>{`${user_name} / ${clinic_name}`}</strong>
            </div>
            <MenuDrawer setClose={() => setShow(false)} />
          </Box>
        </SwipeableDrawer>
      </div>
    </>
  );
}
